import React from 'react';
import { Steps, Tooltip, message } from 'antd';
import { useI18n } from '../i18n';
import { WIZARD_STEPS, getStepStatus, isStepNavigable } from '../utils/wizardHelpers';

/**
 * Horizontal Products → Services → Logistics navigation bar for the
 * SelectionWizard (inquiry-module-redesign, Requirement 5). Wraps Ant
 * Design's <Steps>: current step -> 'process', a step the user has advanced
 * past -> 'finish' (clickable), a not-yet-reachable step -> 'wait' (click
 * shows a tooltip/warning and does not navigate).
 */
export default function WizardStepBar({ currentStep, completedSteps, onNavigate }) {
  const { t } = useI18n();

  const handleChange = (nextStep) => {
    if (isStepNavigable(nextStep, completedSteps)) {
      onNavigate?.(nextStep);
    } else {
      message.warning(t('Complete the previous step first'));
    }
  };

  return (
    <Steps
      current={currentStep}
      onChange={handleChange}
      items={WIZARD_STEPS.map((label, index) => {
        const status = getStepStatus(index, currentStep, completedSteps);
        const navigable = isStepNavigable(index, completedSteps);
        const title = t(label);
        return {
          title: navigable ? title : (
            <Tooltip title={t('Complete the previous step first')}>
              <span>{title}</span>
            </Tooltip>
          ),
          status,
        };
      })}
      style={{ marginBottom: 24 }}
    />
  );
}
